import * as React from 'react';
import './Profile.css';
import { AppStore } from '../../stores';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { IMyGroup } from '../../interfaces/IMyGroup';
import Group from '../tests/teamTest/group/Group';
import GroupService from '../../services/GroupService';
import { IGroup } from '../../interfaces/IGroup';
import StressBarometerService from '../../services/StressBarometerService';
import { IStressBarometer } from '../../interfaces/IStressBarometer';
import StressBarometerCard from '../tests/stressBarometer/stressBarometerCard/StressBarometerCard';

export interface IProps {
  show?: boolean;
  appStore?: AppStore;
}

export interface IState {
  showProfileBackground: boolean;
  loadingGroups: boolean;
  loadingBarometers: boolean;
  stressBarometers?: IStressBarometer[];
}

@inject('appStore')
@observer
export default class Profile extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      showProfileBackground: false,
      loadingGroups: true,
      loadingBarometers: true,
    }
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props.show && !this.props.show) {
      setTimeout(() => {
        this.setState({ showProfileBackground: true });
        this.getMyGroups();
        this.getStressBarometersForUser();
      }, 0)
    };
  }

  private getStressBarometersForUser(): void {
    if (this.props.appStore?.user?.id) {
      this.setState({ loadingBarometers: true });
      StressBarometerService.getStressBarometersForUser(this.props.appStore?.user).then((barometers) => {
        this.setState({ loadingBarometers: false, stressBarometers: barometers });
      });
    }
  }

  private getTypeName(type: number): string | undefined {
    switch (type) {
      case 1:
        return window.loc.strings.type1;
      case 2:
        return window.loc.strings.type2;
      case 3:
        return window.loc.strings.type3;
      case 4:
        return window.loc.strings.type4;
      case 5:
        return window.loc.strings.type5;
      case 6:
        return window.loc.strings.type6;
      case 7:
        return window.loc.strings.type7;
      case 8:
        return window.loc.strings.type8;
      case 9:
        return window.loc.strings.type9;
      default:
        break;
    }
  }

  private async getMyGroups(): Promise<void> {
    if (this.props.appStore?.user?.id) {
      const myGroups: any[] = [];
      this.setState({ loadingGroups: true });
      await GroupService.getGroupsForUser(this.props.appStore?.user?.username).then((groups: IGroup[]) => {
        if (groups?.length > 0) {
          this.props.appStore!.groups = groups;
          this.props.appStore!.groups?.forEach((group: IGroup, index) => {
            if (group.objectId && this.props.appStore!.user?.id) {
              GroupService.getMyGroupMemberInfoForGroup(group.objectId, this.props.appStore!.user?.id).then((groupMemberInfo: any,) => {
                myGroups.push({
                  group,
                  groupMemberInfo: groupMemberInfo?.results?.length > 0 ? groupMemberInfo?.results[0] : undefined
                });
                // if (index === this.props.appStore!.groups?.length - 1) {
                this.props.appStore!.myGroups = myGroups;
                this.setState({ loadingGroups: false });
                // }
              });
            }
          });
        } else {
          this.setState({ loadingGroups: false });
        }
      });
    }
  }

  render() {
    const groups: JSX.Element[] = [];
    if ((this.props.appStore?.groups?.length ?? 0) > 0) {
      this.props.appStore?.myGroups?.forEach((myGroup: IMyGroup) => {
        groups.push(
          <Group
            key={myGroup.group.objectId}
            style={{
              width: this.props.appStore!.isMobile ? "100%" : 420,
            }}
            group={myGroup}
            getMyGroups={() => this.getMyGroups()}
          />
        );
      });
    }
    const stressBarometers: JSX.Element[] = [];
    if ((this.state.stressBarometers?.length ?? 0) > 0) {
      this.state.stressBarometers?.forEach((barometer: IStressBarometer) => {
        stressBarometers.push(
          <div
            key={barometer.objectId}
            className='stressBarometerItem'
            onClick={() => {
              this.props.appStore!.selectedStressBarometer = barometer;
              this.props.appStore!.showProfile = false;
            }}
          >
            <div className='stressBarometerItemTitle'>
              <StressBarometerCard
                stressBarometer={barometer}
              />
            </div>
          </div>
        );
      });
    }
    return (
      <>
        {this.props.appStore!.showProfile &&
          <div
            className='profileOverlay'
            style={{
              opacity: this.state.showProfileBackground ? 0.6 : 0
            }}
          />
        }
        <div
          className='profile'
          style={{
            top: this.props.appStore!.isMobile ? (this.props.appStore!.showProfile ? 0 : screen.height) : 50,
            right: this.props.appStore!.isMobile ? "unset" : (this.props.appStore!.showProfile ? 0 : -500),
            height: this.props.appStore!.isMobile ? "100%" : "calc(100% - 50px)",
          }}
        >
          <div
            className='closeButton'
            onClick={() => {
              this.props.appStore!.showProfile = false;
            }}
          />
          <div className="profileWrapper">
            <div className="headline">{window.loc.strings.yourProfile}</div>
            <div className='areaHeadline'>{(window.loc.strings.yourTestResult || 'Your Test Result').toUpperCase()}</div>
            <div className='enneagramTypeBox'>
              <div
                className='profileEnneagramTypeResultBox'
                style={{
                  backgroundImage: 'url("https://dojo.mindjuice.com/images/enneagramme-texture-bg.png")',
                  backgroundColor: "#064859"
                }}
              >
                <div
                  className="enneagrammyResultNumber"
                  style={{
                    backgroundColor: this.props.appStore!.typeTestColorLighter
                  }}
                >
                  {this.props.appStore!.selectedType ?? "?"}
                </div>
                <div className="enneagrammyResultName">
                  {this.props.appStore!.selectedType ? this.getTypeName(this.props.appStore!.selectedType) : "?"}
                </div>
                <div style={{
                  float: "left",
                  clear: "both",
                  width: "100%",
                  height: 100,
                }}>
                  {this.props.appStore!.isMobile ?
                    <a
                      href="https://apps.apple.com/us/app/enneagrammy/id1033881087"
                      target="_blank"
                    >
                      <div
                        className='profileButton'
                        style={{
                          backgroundColor: "#064859",
                          color: "#ffffff",
                        }}
                      >
                        <div
                          className='profileButtonIcon'
                          style={{
                            backgroundImage: 'url("https://dojo.mindjuice.com/images/tabbar/tests.png")'
                          }}
                        />
                        <div className='profileButtonText' >
                          {window.loc.strings.testIntroStartBtn}
                        </div>
                      </div>
                    </a>
                    :
                    <Link
                      to={`${this.props.appStore!.environment}/tests/19067/test`}
                    >
                      <div
                        className='profileButton'
                        style={{
                          backgroundColor: "#064859",
                          color: "#ffffff",
                        }}
                        onClick={() => {
                          this.props.appStore!.showProfile = false;
                        }}
                      >
                        <div
                          className='profileButtonIcon'
                          style={{
                            backgroundImage: 'url("https://dojo.mindjuice.com/images/tabbar/tests.png")'
                          }}
                        />
                        <div className='profileButtonText' >
                          {window.loc.strings.testIntroStartBtn}
                        </div>
                      </div>
                    </Link>
                  }
                  {this.props.appStore!.selectedType &&
                    (this.props.appStore!.isMobile ?
                      <a
                        href="https://apps.apple.com/us/app/enneagrammy/id1033881087"
                        target="_blank"
                      >
                        <div
                          className='profileButton'
                        >
                          <div
                            className='profileButtonIcon'
                            style={{
                              backgroundImage: 'url("https://dojo.mindjuice.com/images/result-icon.png")'
                            }}
                          />
                          <div className='profileButtonText' >
                            {window.loc.strings.resultTextBtn}
                          </div>
                        </div>
                      </a>
                      :
                      <Link
                        to={`${this.props.appStore!.environment}/tests/19067/results`}
                      >
                        <div
                          className='profileButton'
                          onClick={() => {
                            this.props.appStore!.selectedTypeInfoTab = "result";
                            this.props.appStore!.showEnneagrammyTestResults = true;
                            if (this.props.appStore?.myResult) {
                              this.props.appStore.selectedTestResult = this.props.appStore.myResult;
                            }
                          }}
                        >
                          <div
                            className='profileButtonIcon'
                            style={{
                              backgroundImage: 'url("https://dojo.mindjuice.com/images/result-icon.png")'
                            }}
                          />
                          <div className='profileButtonText' >
                            {window.loc.strings.resultTextBtn}
                          </div>
                        </div>
                      </Link>
                    )
                  }
                </div>
              </div>
            </div>
            <>
              {groups?.length > 0 &&
                <div className='groups'>
                  <div className='areaHeadline'>{(window.loc.strings.groups || 'Groups').toUpperCase()}</div>
                  {groups}
                </div>
              }
            </>
            <>
              {stressBarometers?.length > 0 &&
                <div className='groups'>
                  <div className='areaHeadline'>{(window.loc.strings.stressBarometer || 'Stress Barometer').toUpperCase()}</div>
                  {stressBarometers}
                </div>
              }
            </>
          </div>
        </div>
      </>
    );
  }

}